import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {CtButtonModule, CtControlModule, CtDatatableModule, CtFrameworkModule} from "@ctsolution/ct-framework";
import {ItemSearchComponent} from "./item-search/item-search.component";
import {ItemSelectionComponent} from "./item-selection/item-selection.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatLegacyCardModule as MatCardModule} from "@angular/material/legacy-card";
import {MatLegacyDialogModule as MatDialogModule} from "@angular/material/legacy-dialog";
import {ItemSelectionService} from "./item-selection.service";
import {FlexLayoutModule} from "@angular/flex-layout";
import {ItemSelectionImportModule} from "./item-selection-import/item-selection-import.module";
import { MatIconModule } from "@angular/material/icon";
import {MatLegacyButtonModule as MatButtonModule} from "@angular/material/legacy-button";
import {ItemCreateDialogModule} from "../../../../catalog/catalog-edit/item-create-dialog/item-create-dialog.module";
import {ItemCreateDialogService} from "../../../../catalog/catalog-edit/item-create-dialog/item-create-dialog.service";

@NgModule({
  declarations: [ItemSelectionComponent, ItemSearchComponent],
  imports: [
    CommonModule,
    CtDatatableModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    CtControlModule,
    MatCardModule,
    CtButtonModule,
    MatDialogModule,
    ItemSelectionImportModule,
    CtFrameworkModule,
    MatIconModule,
    MatButtonModule,
    ItemCreateDialogModule
  ],
  exports: [ItemSearchComponent],
  providers: [ItemSelectionService, ItemCreateDialogService]
})
export class ItemSelectionModule {
}
